export enum GroupType {
  ADVERTISER = "advertiser",
  AD_AGENCY = "ad_agency",
  PRODUCTION_COMPANY = "production_company",
  TALENT = "talent",
  TALENT_AGENCY = "talent_agency",
}

export enum GroupSubscriptionStatus {
  PENDING_PAYMENT = "pending_payment",
  TRIALING = "trialing",
  ACTIVE = "active",
  PAST_DUE = "past_due",
  CANCELED = "canceled",
}
